import * as React from 'react';

import { MobileView } from '../../components/ShareReport';
import { META_TITLE_REPORT } from '../../constants/metaTitle';
import { trackLinkReportCopy } from './tracking';

export interface IShareReportMobileProps {
  url: string;
}

export const ShareReportMobile: React.FC<IShareReportMobileProps> = ({ url }) => {
  const onHandleClick = React.useCallback(() => {
    window.navigator.share({
      title: META_TITLE_REPORT,
      url,
    });
    trackLinkReportCopy();
  }, [url]);

  return <MobileView onClick={onHandleClick} />;
};

ShareReportMobile.displayName = 'ShareReportMobile';
